<!--
 * @Author: Eddy Huang
 * @Date: 2021-02-24 16:53:23
 * @LastEditors: Eddy Huang
 * @LastEditTime: 2021-02-25 15:38:24
 * @Description: TODO:
-->
<template>
  <div class="rate" @mouseleave="setState(oldState)">
    <img
      :src="item == 1 ? img1 : img0"
      v-for="(item, index) in state"
      :key="index"
      @mouseenter="handleHover(index)"
      @click="submitState(index)"
    />
  </div>
</template>
<style lang="less" scoped>
.rate {
  margin-left: 9px;
}
</style>
<script>
/* eslint-disable */
const img0 = require("../../assets/img/icon_star_n.png");
const img1 = require("../../assets/img/icon_star_a.png");
export default {
  props: {
    value: {
      type: Number,
      required: true,
      default: 3,
    },
    disabled: {
      type: Boolean | String,
      default: true,
    },
  },
  watch: {
    value(v) {
      this.oldState = v - 1;
      this.setState(this.oldState);
    },
  },
  methods: {
    setState(index) {
      this.state = [
        ...new Array(index + 1).fill(1),
        ...new Array(4 - index).fill(0),
      ];
    },
    submitState(index) {
      if (this.disabled) return;
      this.oldState = index;
      this.$emit("input", this.oldState + 1);
    },
    handleHover(index) {
      if (this.disabled) return;
      this.setState(index);
    },
  },
  data() {
    return {
      state: [1, 0, 0, 0, 0],
      img0,
      img1,
      oldState: 0,
    };
  },
  created() {
    this.oldState = this.value - 1;
    this.setState(this.oldState);
  },
};
</script>
